import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
// import { jwtDecode } from "jwt-decode";

function Signup() {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    password: "",
    phone_number: "",
    seller_type: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    // ✅ Email format validation (frontend)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      alert("❌ Please enter a valid email address.");
      return;
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/signup`, form);
      alert(res.data.message || "Signup successful!");
      navigate("/login");
    } catch (err) {
      alert(err.response?.data?.error || "Signup failed");
    }
  };

  // const handleGoogleSuccess = (credentialResponse) => {
  //   const decoded = jwtDecode(credentialResponse.credential);
  //   localStorage.setItem(
  //     "user",
  //     JSON.stringify({
  //       email: decoded.email,
  //       name: decoded.name,
  //     })
  //   );
  //   navigate("/");
  // };

  const handleGoogleSuccess = async (credentialResponse) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/google`,
      {
        credential: credentialResponse.credential,
      }
    );

    localStorage.setItem("user", JSON.stringify(res.data.user));
    navigate("/post");
  } catch (err) {
    console.error(err);
    alert("❌ Google signup failed");
  }
}; 

  const handleGoogleFailure = () => {
    alert("❌ Google signup failed");
  };

  return (
    <div className="container mt-5 d-flex justify-content-center">
      <div className="form-container-wrapper">
        <div className="text-center mb-3">
          <h6>Create Your Account</h6>
          <p>Join now and start listing your cars</p>
        </div>

        <form onSubmit={handleSignup} className="form-container mb-4">
          <input
            type="text"
            name="full_name"
            className="form-control mb-2"
            placeholder="Full Name"
            value={form.full_name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            className="form-control mb-2"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone_number"
            className="form-control mb-2"
            placeholder="Phone Number"
            value={form.phone_number}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            className="form-control mb-2"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <select
            name="seller_type"
            className="form-control mb-2"
            value={form.seller_type}
            onChange={handleChange}
            required
          >
            <option value="">Select Seller Type</option>
            <option value="Private">Private</option>
            <option value="Broker">Broker</option>
            <option value="Dealership">Dealership</option>
            <option value="Other">Other</option>
          </select>

          <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-secondary w-100 mb-1">
              Register
            </button>
          </div>

          <div className="text-center mb-2 google-login-btn">
            <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleFailure} />
          </div>

          <div className="text-center">
            Already have an account?{" "}
            <Link to="/login" className="text-decoration-none">
              Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Signup;
